import { render, staticRenderFns } from "./KmtForm.vue?vue&type=template&id=122bf07c&scoped=true"
import script from "./KmtForm.vue?vue&type=script&lang=js"
export * from "./KmtForm.vue?vue&type=script&lang=js"
import style0 from "./KmtForm.vue?vue&type=style&index=0&id=122bf07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122bf07c",
  null
  
)

export default component.exports